import UserCartComponent from "../MVPComponents/UserCartComponent";

const UserCart = () => {
  return (
    <div>
      <UserCartComponent />
    </div>
  );
};

export default UserCart;
